import Vue from 'vue';
// eslint-disable-next-line
import Posts from '@/api/resources/posts';

const state = {
  post: null,
  posts: [],
  toggleReportDialog: false,
  findPostSuccess: false,
  noResults: false,
  report: null,
};

const getters = {
  getPost: () => (state.post),
  posts: () => (state.posts),
  toggleReportDialog: () => (state.toggleReportDialog),
  findPostSuccess: () => (state.findPostSuccess),
};

const actions = {
  createReport({ commit }, params) {
    Posts.report(params).then((response) => {
      commit('setReport', response);
      commit('toggleReportDialog');
    });
  },
  changeReportDialog({ commit }) {
    commit('toggleReportDialog');
  },
  createPost({ commit, dispatch }, params) {
    dispatch('initLoading');
    Posts.create(params).then((response) => {
      dispatch('removeLoading');
      commit('setPost', response);
    });
  },
  updatePost({ commit }, params) {
    Posts.update(params).then((response) => {
      commit('setPost', response);
    });
  },
  // eslint-disable-next-line
  getAllPosts({ commit, dispatch }, params) {
    Posts.index(params).then((response) => {
      if (response.pagy.next) {
        dispatch('nextPage');
        dispatch('loaded');
      } else {
        dispatch('complete');
      }
      commit('setPosts', response.posts);
    });
  },
  deletePost({ commit }, postId) {
    Posts.delete(postId).then(() => {
      commit('removePost', postId);
    });
  },
  findPost({ commit, dispatch }, params) {
    dispatch('initLoading');
    Posts.show(params).then((response) => {
      commit('setPost', response);
      commit('togglePostSuccess');
      dispatch('removeLoading');
    });
  },
  clearPosts({ commit }) {
    commit('clearPosts');
  },
  changePostSucess({ commit }) {
    commit('togglePostSuccess');
  },
};

const mutations = {
  setPost($state, payload) {
    const stateCopy = $state;
    stateCopy.post = payload;
  },
  setPosts($state, payload) {
    const stateCopy = $state;
    stateCopy.posts = stateCopy.posts.concat(payload);
  },
  removePost($state, payload) {
    const stateCopy = $state;
    const { posts } = stateCopy;
    posts.splice(posts.findIndex(post => post.id === payload), 1);
    stateCopy.post = null;
    Vue.set(stateCopy, 'posts', posts);
  },
  clearPosts($state) {
    const stateCopy = $state;
    stateCopy.posts = [];
  },
  toggleReportDialog($state) {
    const stateCopy = $state;
    stateCopy.toggleReportDialog = !stateCopy.toggleReportDialog;
  },
  togglePostSuccess($state) {
    const stateCopy = $state;
    stateCopy.findPostSuccess = !stateCopy.findPostSuccess;
  },
  setReport($state, payload) {
    const stateCopy = $state;
    stateCopy.report = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
